import { Question } from './../interfaces/Question';
import { PersonContactInfo } from "../interfaces/Person"
import { PaymentChoice } from '../interfaces/Payment';

interface Membership {
    contactInformation?: PersonContactInfo
    paymentInformation: PaymentChoice
    questions?: Question[]
    union?: string,
    consentToAuthorization: boolean | null,    
    culture?: string;
    umbracoPageId: number | undefined;
}

interface MembershipAnswer { 
    [key: string]: { 
        key: string, 
        answer: string | null, 
        additionalAnswers: string[] | null
    } 
}

interface ResultMembership {
    contactInformation: PersonContactInfo | null,
    answers: MembershipAnswer | null,
    union: null | {
        company: string,
        authorization: boolean | null
    }
    paymentInformation: PaymentChoice | null
    culture: string;
    umbracoPageId: number | undefined;
}

export const createMembership = ({ contactInformation, questions, union, consentToAuthorization, paymentInformation, culture, umbracoPageId}: Membership) => {

    let membership: ResultMembership = {
        contactInformation: null,
        answers: null,
        union: null,
        paymentInformation: null,
        culture: culture || 'sv-SE',
        umbracoPageId: umbracoPageId
    }

    if ( contactInformation ) {
        membership = {
            ...membership,
            contactInformation: {
                ...contactInformation,
                phoneNumber: contactInformation.phoneNumber.replace(/-|\s/g,"") // Replace whitespace and hyphens
            }
        }
    }

    if ( questions ) {

        let answers = questions.reduce((result: MembershipAnswer, question) => {

            const complementaryAnswers = typeof question.complementaryAnswers !== 'undefined' ?
                Object.values(question.complementaryAnswers) : null

            result[question.key] = {
                key: question.key,
                answer: question.givenAnswer,
                additionalAnswers: complementaryAnswers ? complementaryAnswers : null
            }
            return result
        }, {})

        membership = {
            ...membership,
            answers
        }
    }

    if ( union ) {
        membership = {
            ...membership,
            union: {
                company: union,
                authorization: consentToAuthorization ? consentToAuthorization : null
            }
        }
    }

    if ( paymentInformation ) {
        membership = {
            ...membership,
            paymentInformation: paymentInformation
        }
    }

    return membership

}

